module.exports = __webpack_public_path__ + "static/media/HostAStay-logo.78f6aea9.png";